import cn from "classnames";
import { Transition } from "components/shared/column";
import { Select } from "components/shared/form";
import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { isRegionDryingPeriodsEnabledForClients } from "helpers/regionDryingPeriods";
import React, { Component } from "react";
import { list as logistsList } from "sources/books/employees";
import { numbersList as trucksList } from "sources/books/trucks";
import { getUsedCarTypes, getUsedTrailerTypes } from "sources/catalogs";

export default class MapFilter extends Component {
    state = {
        isFilterOpened: true,
    };

    toggleFilterPanel = () => {
        const { isFilterOpened } = this.state;
        return this.setState({ isFilterOpened: !isFilterOpened });
    };

    mergeParams = (name, value) => {
        const params = this.props.params || {};
        if (value === "-" || value === null) {
            delete params[name];
        } else {
            params[name] = value;
        }
        return params;
    };

    toggleOnlyMyCars = () => {
        const {
            mergeParams,
            params,
            profile: { id },
        } = this.props;
        const logistId = params["car/logistId"];
        const currentUserId = parseInt(id);
        const value = logistId && logistId.length === 1 && logistId[0] === currentUserId ? null : [currentUserId];
        mergeParams(this.mergeParams("car/logistId", value));
    };

    onlyMyCarsFilter = () => {
        const {
            profile: { id },
            params,
        } = this.props;
        const logistId = params["car/logistId"];
        const currentUserId = parseInt(id);
        const onlyMyCarsSelected = logistId && logistId.length === 1 && logistId[0] === currentUserId;
        const btnClasses = cn("checkbox d-inline-block", { "checkbox--checked": onlyMyCarsSelected });
        return (
            <div className="form-group">
                <div className="col-form-label-sm" onClick={this.toggleOnlyMyCars}>
                    <div className={btnClasses} />
                    &nbsp;
                    <div className="d-inline-block checkbox__text">Показать только мои машины</div>
                </div>
            </div>
        );
    };

    regionDryingPeriodsFilter = () => {
        const { showRegionDryingFilters, toggleShowRegionDryingFilters } = this.props;
        const btnClasses = cn("checkbox d-inline-block", { "checkbox--checked": showRegionDryingFilters });
        return (
            <div className="form-group">
                <div className="col-form-label-sm" onClick={toggleShowRegionDryingFilters}>
                    <div className={btnClasses} />
                    &nbsp;
                    <div className="d-inline-block checkbox__text">Отобразить периоды просушки дорог 2026</div>
                </div>
            </div>
        );
    };

    onSelectChange = ({ name, value }) => {
        this.props.mergeParams(this.mergeParams(name, value.length === 0 ? null : value));
    };

    logistFilter = () => {
        const props = {
            url: logistsList,
            inputProps: { name: "car/logistId" },
            propName: "fullNameOrEmail",
            wrapper: "book-field",
            onChange: this.onSelectChange,
            value: this.props.params["car/logistId"],
            bWrapper: "row",
            ...defaultMultipleSelectProps,
            components: { ValueContainer },
        };
        return (
            <div className="form-group">
                <small className="text-muted">Выберите логиста:</small>
                <Select {...props} />
            </div>
        );
    };

    truckFilter = () => {
        const props = {
            url: trucksList,
            inputProps: { name: "car/id" },
            propName: "number",
            wrapper: "book-field",
            onChange: this.onSelectChange,
            value: this.props.params["car/id"],
            bWrapper: "row",
            ...defaultMultipleSelectProps,
            components: { ValueContainer },
        };
        return (
            <div className="form-group">
                <small className="text-muted">Выберите грузовик:</small>
                <Select {...props} />
            </div>
        );
    };

    carTypeFilter = () => {
        const props = {
            inputProps: { name: "car/typeId" },
            url: getUsedCarTypes,
            propName: "displayName",
            wrapper: "book-field",
            onChange: this.onSelectChange,
            value: this.props.params["car/typeId"],
            bWrapper: "row",
            ...defaultMultipleSelectProps,
            components: { ValueContainer },
        };
        return (
            <div className="form-group">
                <small className="text-muted">Выберите тип грузовика:</small>
                <Select {...props} />
            </div>
        );
    };

    trailerTypeFilter = () => {
        const props = {
            inputProps: { name: "trailerTypeIds" },
            url: getUsedTrailerTypes,
            propName: "displayName",
            wrapper: "book-field",
            onChange: this.onSelectChange,
            value: this.props.params.trailerTypeIds,
            bWrapper: "row",
            ...defaultMultipleSelectProps,
            components: { ValueContainer },
        };
        return (
            <div className="form-group">
                <small className="text-muted">Выберите тип прицепа:</small>
                <Select {...props} />
            </div>
        );
    };

    filtersSidebar = () => {
        return (
            <div className="map-sidebar">
                <Transition dir="right-sidebar">
                    <div className="map-sidebar__wrap">
                        <div className="map-sidebar__head">
                            <div className="book-list__head-close close close--sm" onClick={this.toggleFilterPanel} />
                            <div className="book-list__head-title">Фильтры</div>
                        </div>
                        <div className="map-sidebar__body">
                            {this.logistFilter()}
                            {this.truckFilter()}
                            {this.carTypeFilter()}
                            {this.trailerTypeFilter()}
                            {this.onlyMyCarsFilter()}
                            {isRegionDryingPeriodsEnabledForClients && this.regionDryingPeriodsFilter()}
                        </div>
                    </div>
                </Transition>
            </div>
        );
    };

    render() {
        const { params, mergeParams, hideZoomControl } = this.props;
        if (!params || !mergeParams) {
            return null;
        }
        const { isFilterOpened } = this.state;
        const cname = cn("map-filter", {
            "map-filter__no-zoom": !!hideZoomControl,
        });
        const filterBtnCname = cn("map-filter__button", {
            "map-filter__button--active": Object.keys(params).length > 0,
        });
        return (
            <>
                <div className={cname}>
                    <div className={filterBtnCname} onClick={this.toggleFilterPanel} />
                </div>
                {isFilterOpened && this.filtersSidebar()}
            </>
        );
    }
}
